import { createUseStyles } from 'react-jss';
import { CommunicationColors } from '@bingads-webui-react/fabric-control';

export const useStyles = createUseStyles({
  RecommendationMessageBar: {
    background: CommunicationColors.tint40,
    margin: '16px auto',
    padding: '0 8px',
    backgroundClip: 'content-box',
  },
  WarningMessageBar: {
    margin: '16px auto',
    padding: '0 8px',
    backgroundClip: 'content-box',
  },
  Icon: {
    color: CommunicationColors.primary,
  },
  RecommendationMessageText: {
    fontSize: 'small',
  },
  WarningMessageText: {
    fontSize: 'small',
  },
  Container: {
    minWidth: '950px',
  },
});
